import { render, staticRenderFns } from "./FormInscription.vue?vue&type=template&id=2e9d0696&scoped=true&"
var script = {}
import style0 from "./FormInscription.vue?vue&type=style&index=0&id=2e9d0696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9d0696",
  null
  
)

export default component.exports